
import { mapActions, mapGetters } from 'vuex';
import getIDfromURL from '../getIDfromURL';
import 'vueperslides/dist/vueperslides.css';

export default {
  name: 'InfoBeforeEvent',
  data() {
    return {
      slide: 0,
      sliding: null,
    };
  },
  computed: {
    ...mapGetters({
      reasons: 'events/fetchReasonsToAttend',
      session: 'events/fetchKnowledgeSharingSession',
      sponsors: 'events/strategicSponsors',
      parallelEvents: 'events/parallelEvents',
      event: 'events/fetchEvent',
    }),
  },
  watch: {
    '$route.params.eventId': {
      immediate: true,
      async handler(eventId) {
        if (eventId) {
          await this.fetchKnowledgeSharingSession(eventId);
          await this.fetchReasonsToAttend(eventId);
          await this.strategicSponsors(eventId);
          await this.fetchParallelEvents(eventId);
        }
      },
    },
  },
  methods: {
    ...mapActions({
      fetchReasonsToAttend: 'events/fetchReasonsToAttend',
      fetchKnowledgeSharingSession: 'events/fetchKnowledgeSharingSession',
      strategicSponsors: 'events/strategicSponsors',
      fetchParallelEvents: 'events/fetchParallelEvents',
    }),
    onSlideStart() {
      this.sliding = true;
    },
    goToAgenda() {
      if (this.$route.name === 'PublicInfo') {
        this.$router.push({ name: 'PublicAgenda' });
      } else {
        this.$router.push({ name: 'Agenda' });
      }
    },
    onSlideEnd() {
      this.sliding = false;
    },
    getURL(url) {
      return getIDfromURL(url);
    },
  },
};
